import type { BudgetRule, BudgetRuleKind } from "@/schemas";

export interface BudgetFormState {
  kind: BudgetRuleKind;
  label: string;
  category: string;
  amount: string;
  currencyAssetId: string;
  dayOfMonth: string;
  linkedBookId: string;
  enabled: boolean;
  notes: string;
}

export interface GroupedCategory {
  name: string;
  total: number;
  rules: BudgetRule[];
}

export const DEFAULT_FORM: BudgetFormState = {
  kind: "expense",
  label: "",
  category: "",
  amount: "",
  currencyAssetId: "",
  dayOfMonth: "1",
  linkedBookId: "",
  enabled: true,
  notes: "",
};

export const occurrenceStatusClasses: Record<string, string> = {
  planned: "bg-muted text-muted-foreground",
  generated: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  matched:
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400",
  review_required:
    "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400",
};
